<template>
    <div>
        <!-- <div v-if="column.field==='weekProperties'&row !==null"> {{ row.weekProperties }}</div> -->
        <div v-if="(column.field === 'weekProperties') & (row !== null)">{{ weekProperties(row.weekProperties) }}</div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    filters: {
        meetPersonTypefilter(val) {
            if (val === 1) {
                return '内部人员'
            } else if (val === 2) {
                return '外部人员'
            } else if (val === 3) {
                return '联络人员'
            }
        }
    },
    components: {},
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        },
        column: {
            type: Object,
            default: function () {
                return {}
            }
        },
        index: {
            type: String,
            default: function () {
                return '0'
            }
        }
    },
    data() {
        return {
            dialogVisible: false
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {},
    methods: {
        weekProperties(item) {
            // debugger
            var arr = item.split(',')
            // console.log('hahah', arr)
            if (arr.length === 7) {
                return this.$tx('hygl.components.everyDay', '每天')
            } else if (arr.length === 5) {
                return this.$tx('hygl.components.workDay', '工作日’')
            } else {
                return item
            }
            // arr.forEach(el => {
            //     console.log('hahah', el)
            //     debugger
            //     if (el === '周一' && el === '周二' && el === '周三' && el === '周四' && el === '周五' && el === '周六' && el === '周日') {
            //         return '每天'
            //     } else if (el === '周一' && el === '周二' && el === '周三' && el === '周四' && el === '周五') {
            //         return '工作日'
            //     } else {
            //         return el
            //     }
            // })
        }
    }
}
</script>

<style scoped lang="scss">
</style>
